<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<div
  class="navbar__item dropdown"
  [ngClass]="{
    'no-image': !item.customizeLink.image,
    bold: item.customizeLink.bold,
    italic: item.customizeLink.italic,
    underline: item.customizeLink.underline,
    'shape-filled': shapeColor,
    active: isActive() || isOpen(),
    show: isOpen(),
  }"
  (openChange)="toggleDropdown()"
>
  @if (!item.childLinks || item.childLinks.length === 0) {
    <a
      class="navigation__list-item-link"
      data-gtmaction="event_menu_click"
      data-gtmcategory="event_informational_action"
      [routerLink]="[item.linkedPage | localeData]"
      [ngClass]="{ 'btn-underline-hov': !shapeColor }"
      [ngStyle]="{ 'background-color': shapeColor ? shapeColor : null, color: fontColor ? fontColor : null }"
      (click)="clickItem(); gtmEvent($event)"
      (mouseenter)="prefetchPage(item)"
    >
      @if (item.customizeLink.image) {
        <div class="navbar__item-img">
          <img
            class="lazyloaded d-lg-none"
            aria-hidden="true"
            tabindex="-1"
            ngSrcset="40w"
            width="40"
            height="40"
            [ngSrc]="item.customizeLink.image"
            [alt]="item.title"
            [loaderParams]="{ builder: true }"
          />
        </div>
      }
      <span [innerHtml]="item.title"></span>
    </a>
  }

  @if (item.childLinks && item.childLinks.length > 0) {
    <ng-container>
      <button
        class="dropdown-toggle btn-dropdown"
        type="button"
        role="button"
        data-gtmaction="event_menu_click"
        data-gtmcategory="event_informational_action"
        aria-haspopup="true"
        aria-expanded="false"
        [ngClass]="{ 'btn-underline-hov': !shapeColor }"
        [id]="'dropdown-' + index"
        [ngStyle]="{ 'background-color': shapeColor ? shapeColor : null, color: fontColor ? fontColor : null }"
        (click)="toggleDropdown(); gtmEvent($event)"
        (mouseenter)="prefetchPage(item)"
      >
        @if (item.customizeLink.image) {
          <div class="navbar__item-img">
            <img
              class="lazyloaded d-lg-none"
              aria-hidden="true"
              tabindex="-1"
              ngSrcset="40w"
              width="40"
              height="40"
              [ngSrc]="item.customizeLink.image"
              [alt]="item.title"
              [loaderParams]="{ builder: true }"
            />
          </div>
        }
        <span [innerHtml]="item.title"></span>
        <i class="fal fa-chevron-down" [ngClass]="{ rotate: isOpen() }"></i>
      </button>

      <div
        [ngClass]="{ show: isOpen() }"
        class="menu-backdrop"
        tabindex="0"
        (keypress)="$event.stopPropagation(); closeDropdown()"
        (click)="$event.stopPropagation(); closeDropdown()"
      ></div>

      <div
        class="dropdown-menu megamenu"
        [id]="'megamenu-' + index"
        [attr.aria-labelledby]="'dropdown-' + index"
        [ngClass]="{ show: isOpen() }"
      >
        <div class="container">
          @if (!linksMenu) {
            <app-store-nav-dropdown [item]="item" [isVisible]="isOpen()" (eventClickItem)="closeDropdown()" />
          } @else {
            <app-store-nav-dropdown-links [item]="item" [isVisible]="isOpen()" (eventClickItem)="closeDropdown()" />
          }
          <button
            data-internal-id="submenu"
            class="close d-none d-lg-flex"
            type="button"
            data-toogle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            title="Chiudi"
            tabindex="0"
            (keypress)="$event.stopPropagation(); closeDropdown()"
            (click)="$event.stopPropagation(); closeDropdown()"
          >
            <i class="fal fa-times"></i>
          </button>
        </div>
      </div>
    </ng-container>
  }
</div>
